import { render, staticRenderFns } from "./AllowanceDocument.vue?vue&type=template&id=5f2ec205"
import script from "./AllowanceDocument.vue?vue&type=script&lang=js"
export * from "./AllowanceDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports